import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";

export class ColorBetsPanel extends ObservableContainer {

    private buttons: Array<Button> = [];

    private readonly RED_COLOR_NUMBERS: Array<number> =
        [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
    private readonly BLACK_COLOR_NUMBERS: Array<number> =
        [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];

    constructor(redColorButtonPositionX: number,
                blackColorButtonPositionX: number,
                colorButtonPositionY: number) {
        super();
        this.createAndAddRedBetButton(redColorButtonPositionX, colorButtonPositionY);
        this.createAndAddBlackBetButton(blackColorButtonPositionX, colorButtonPositionY);
    }

    public getButtonPosition(lowNumbers: boolean): PIXI.Point {
        if (lowNumbers) {
            return (this.buttons[0].position as PIXI.Point);
        } else {
            return (this.buttons[1].position as PIXI.Point);
        }
    }

    private onValueChosen(redColorSelected: boolean): void {
        if (redColorSelected) {
            this.callOnClickedSubscribers(redColorSelected, this.RED_COLOR_NUMBERS);
        } else {
            this.callOnClickedSubscribers(redColorSelected, this.BLACK_COLOR_NUMBERS);
        }
    }

    private onHover(redColorSelected: boolean): void {
        if (redColorSelected) {
            this.callOnPointerDownSubscribers(redColorSelected, this.RED_COLOR_NUMBERS);
        } else {
            this.callOnPointerDownSubscribers(redColorSelected, this.BLACK_COLOR_NUMBERS);
        }
    }

    private onHoverOutside(redColorSelected: boolean): void {
        if (redColorSelected) {
            this.callOnPointerUpSubscribers(redColorSelected, this.RED_COLOR_NUMBERS);
        } else {
            this.callOnPointerUpSubscribers(redColorSelected, this.BLACK_COLOR_NUMBERS);
        }
    }

    private createAndAddRedBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, true);
        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private createAndAddBlackBetButton(positionX: number, positionY: number): void {
        const button = new Button(data.images.colorEvenLowBaseState, data.images.colorEvenLowHoverDisableState,
            data.images.colorEvenLowHoverDisableState, data.images.colorEvenLowHoverDisableState);

        this.initializeBetButtonBehavior(button, false);
        button.position.x = positionX;
        button.position.y = positionY;
        this.buttons.push(button);
        this.addChild(button);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/ColorBetsPanel.ts